import '../style.css';

export function FH1Well(props) {
  return <div className='fh1-well' style={props.style}>
    {props.children}
  </div>;
}
